import * as React from "react";
import { FilterState } from "../providers/Filter";

type FilterContext = {
  isLoading: boolean;
  error: Error;
  data: null;
  state: FilterState;
  dispatch: any;
};

const ctx: FilterContext = {
  isLoading: true,
  error: null,
  data: null,
  state: null,
  dispatch: () => {},
};

const FilterContext = React.createContext(ctx);

export default FilterContext;
